import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class EventoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let event = model;

        if ( !event.descricao || !event.descricao.trim()) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        if ( !validated ){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }
        
        return validated;
    }

}